import { Dictionary } from 'lodash'

export const IS_LOCALHOST = process.env.APP_ENV === 'development'
export const IS_PRODUCTION = process.env.APP_ENV === 'production'

// These origins are only used in vercel server-side edge's runtime.
// They're needed because there's no browser origin in there to achieve CORS validation.
const CLIENT_ORIGIN_MAPPING: Dictionary<string> = {
  development: 'http://localhost:3001',
  dev: 'https://app.testing.splits.org',
  staging: 'https://app.staging.splits.org',
  production: 'https://app.splits.org',
}

export const CLIENT_ORIGIN =
  CLIENT_ORIGIN_MAPPING[process.env.APP_ENV ?? 'development']
